import { render, staticRenderFns } from "./GroupTaskDetails.vue?vue&type=template&id=0fa61246&"
import script from "./GroupTaskDetails.vue?vue&type=script&lang=js&"
export * from "./GroupTaskDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports